const productApps = document.querySelectorAll('.product-application');
const solutionsWrapper = document.getElementById('solutionsWrapper');

if (productApps) {
  productApps.forEach(function (app) {
    app.addEventListener('click', function () {
      //sibs
      productApps.forEach(function (sib) {
        sib.parentElement.querySelector('.title').classList.remove('fill-current');
        sib.querySelector('.outline').setAttribute('stroke', '#dcddde');
        sib.querySelector('g').classList.remove('fill-current');

        let active = solutionsWrapper.querySelector('div.block')

        if(active) {
          active.classList.add('hidden');
          active.classList.remove('block');
        }

      });

      app.parentElement.querySelector('.title').classList.toggle('fill-current');
      app.querySelector('.outline').setAttribute('stroke', '#CFD344');

      solutionsWrapper.querySelector('.' + app.id).classList.remove('hidden');
      solutionsWrapper.querySelector('.' + app.id).classList.add('block');
    });

    if(app.id === 'ventilation-air-quality'){
      app.dispatchEvent(new Event('click'));
    }
  });
}
